import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQAccordion({ faqs, testid = "faq-accordion" }) {
    if (!faqs || faqs.length === 0) return null;
    return (
        <Accordion type="single" collapsible className="w-full" data-testid={testid}>
            {faqs.map((f, i) => (
                <AccordionItem
                    key={f.id || i}
                    value={f.id || `item-${i}`}
                    className="border-slate-200"
                >
                    <AccordionTrigger
                        className="text-left font-semibold text-slate-950 hover:no-underline py-5"
                        data-testid={`faq-trigger-${i}`}
                    >
                        {f.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-slate-600 leading-relaxed text-[15px] pb-5">
                        {f.answer}
                    </AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    );
}
